import React, { useState } from 'react';
import PropTypes from 'prop-types';
import 'components/modal/modal.style.scss';
import Button from '../../button/button';

const PhoneSample = ({ title, text, buttonLabel, onClick }) => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isValid, setIsValid] = useState(false);

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\s+/g, ''); // Remove spaces
    const phoneRegex = /^((\+|00)?[1-9]\d{8,14})$/; // Ensures at least 9 digits after + or 00
    setPhoneNumber(value);
    setIsValid(phoneRegex.test(value));
  };

  const handleConfirm = () => {
    if (isValid) {
      onClick(phoneNumber);
    }
  };

  return (
    <div className="w-100">
      <h2 className="m-0 p-0">{title}</h2>
      {text && <p className="light">{text}</p>}
      <div className='inline-column w-100' style={{ maxWidth: '260px' }}>
        <input
          autoFocus 
          type="text"
          className="input-medium-default" 
          placeholder="Insira Telefone (Ex: +351987654321)"
          minLength={9}
          maxLength={14}
          value={phoneNumber} 
          onChange={handleInputChange} 
          required
        />
      </div>
      {
      <Button
        value={buttonLabel}
        onClick={handleConfirm}
        type="button"
        disabled={!isValid} 
        className="cta-button-primary d-medium w-50 mt-4"
      />
      }
    </div>
  );
};

PhoneSample.propTypes = {
  title: PropTypes.string, 
  text: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PhoneSample;
